/* ============================================================
   section-video-carousel.js — v3 (performance fix)
   assets/section-video-carousel.js
   ============================================================ */

(function () {
  'use strict';

  function initCarousel(section) {
    var track     = section.querySelector('[data-vc-track]');
    var trackWrap = section.querySelector('[data-vc-track-wrap]');
    var dotsWrap  = section.querySelector('[data-vc-dots]');
    var prevBtn   = section.querySelector('[data-vc-prev]');
    var nextBtn   = section.querySelector('[data-vc-next]');

    if (!track) return;

    var direction     = section.dataset.direction || 'ltr';
    var cards         = Array.from(track.querySelectorAll('[data-vc-card]'));
    var totalCards    = cards.length;
    var currentIndex  = 0;
    var resumeTimer   = null;
    var isAuto        = true;
    var visibleVideos = new Set();

    if (totalCards === 0) return;

    function resumeVisibleVideos() {
      visibleVideos.forEach(function (video) {
        video.muted = true;
        var p = video.play();
        if (p !== undefined) p.catch(function () {});
      });
    }

    /* Clone cards for seamless infinity loop */
    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('vc-clone');

      var origVid  = card.querySelector('[data-vc-video]');
      var cloneVid = clone.querySelector('[data-vc-video]');
      if (origVid && cloneVid) {
        cloneVid.src = origVid.src;
        cloneVid.muted = true;
      }

      var cloneLink = clone.querySelector('.vc-card__link');
      if (cloneLink) cloneLink.style.pointerEvents = 'none';

      track.appendChild(clone);
    });

    /* Lazy-play: a video only loads/plays once its card is actually visible */
    var allCardEls = track.querySelectorAll('[data-vc-card]');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('[data-vc-video]');
        if (!video) return;
        if (entry.isIntersecting) {
          visibleVideos.add(video);
          video.muted = true;
          var p = video.play();
          if (p !== undefined) p.catch(function () {});
        } else {
          visibleVideos.delete(video);
          video.pause();
        }
      });
    }, { root: trackWrap, rootMargin: '0px 150px 0px 150px', threshold: 0.25 });

    allCardEls.forEach(function (el) { observer.observe(el); });

    function startAutoScroll() {
      track.style.transform  = '';
      track.style.transition = '';
      track.style.animation  = '';
      void track.offsetWidth;
      track.classList.remove('is-paused', 'vc-rtl');
      track.classList.add('is-auto-scrolling');
      if (direction === 'rtl') track.classList.add('vc-rtl');
      isAuto = true;
    }

    function pauseAutoScroll() {
      track.classList.add('is-paused');
    }

    function stopAutoScroll() {
      var currentTransform = window.getComputedStyle(track).transform;
      track.classList.remove('is-auto-scrolling', 'is-paused', 'vc-rtl');
      track.style.animation  = 'none';
      track.style.transform  = currentTransform;
      track.style.transition = 'none';
      isAuto = false;
    }

    trackWrap.addEventListener('mouseenter', function () {
      if (isAuto) pauseAutoScroll();
    });
    trackWrap.addEventListener('mouseleave', function () {
      if (isAuto) track.classList.remove('is-paused');
      resumeVisibleVideos();
    });

    function getCardWidth() {
      var card = track.querySelector('[data-vc-card]');
      if (!card) return 0;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 14;
      return card.offsetWidth + gap;
    }

    function goTo(index, animate) {
      if (index < 0) index = totalCards - 1;
      if (index >= totalCards) index = 0;
      currentIndex = index;
      track.style.transition = animate !== false
        ? 'transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)'
        : 'none';
      track.style.transform = 'translateX(-' + (currentIndex * getCardWidth()) + 'px)';
      updateDots();
    }

    function scheduleResume() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        startAutoScroll();
        resumeVisibleVideos();
      }, 3000);
    }

    function manualNav(delta) {
      stopAutoScroll();
      goTo(currentIndex + delta, true);
      scheduleResume();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { manualNav(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { manualNav(1); });

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalCards; i++) {
        (function (idx) {
          var dot = document.createElement('button');
          dot.className = 'vc-dot' + (idx === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to video ' + (idx + 1));
          dot.addEventListener('click', function () {
            stopAutoScroll();
            goTo(idx, true);
            scheduleResume();
          });
          dotsWrap.appendChild(dot);
        })(i);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.vc-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === currentIndex);
      });
    }

    buildDots();

    var dragStartX = null, dragStartY = null, isDragging = false, dragBaseX = 0;

    function getCurrentTranslateX() {
      var matrix = window.getComputedStyle(track).transform;
      if (matrix && matrix !== 'none') {
        var m = matrix.match(/matrix.*\((.+)\)/);
        if (m) return parseFloat(m[1].split(', ')[4]) || 0;
      }
      return 0;
    }

    function onDragStart(x, y) {
      dragStartX = x; dragStartY = y; isDragging = false;
      stopAutoScroll();
      dragBaseX = getCurrentTranslateX();
      track.style.transition = 'none';
      track.style.transform  = 'translateX(' + dragBaseX + 'px)';
    }

    function onDragMove(x, y) {
      if (dragStartX === null) return;
      var dx = x - dragStartX;
      var dy = y - dragStartY;
      if (!isDragging) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          dragStartX = null; dragStartY = null;
          startAutoScroll();
          return;
        }
        isDragging = true;
      }
      track.style.transform = 'translateX(' + (dragBaseX + dx) + 'px)';
    }

    function onDragEnd(x) {
      if (dragStartX === null) return;
      var diff = dragStartX - x;
      if (isDragging && Math.abs(diff) > 40) {
        stopAutoScroll();
        goTo(currentIndex + (diff > 0 ? 1 : -1), true);
      } else {
        track.style.transition = 'transform 0.4s cubic-bezier(0.25,0.46,0.45,0.94)';
        track.style.transform  = 'translateX(-' + (currentIndex * getCardWidth()) + 'px)';
      }
      scheduleResume();
      dragStartX = null; dragStartY = null; isDragging = false;
    }

    trackWrap.addEventListener('mousedown', function (e) {
      e.preventDefault();
      onDragStart(e.clientX, e.clientY);
    });
    window.addEventListener('mousemove', function (e) {
      if (dragStartX !== null) onDragMove(e.clientX, e.clientY);
    });
    window.addEventListener('mouseup', function (e) {
      if (dragStartX !== null) onDragEnd(e.clientX);
    });

    trackWrap.addEventListener('touchstart', function (e) {
      onDragStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    trackWrap.addEventListener('touchmove', function (e) {
      if (dragStartX === null) return;
      if (isDragging) e.preventDefault();
      onDragMove(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: false });
    trackWrap.addEventListener('touchend', function (e) {
      if (dragStartX !== null) onDragEnd(e.changedTouches[0].clientX);
    });

    startAutoScroll();
  }

  function init() {
    document.querySelectorAll('[data-vc-section]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-vc-section]');
    if (s) initCarousel(s);
  });

})();